<div>
    <h1 class="custom-header" style="font-weight: 300;" mat-dialog-title>
        <i class="fa fa-times" aria-hidden="true"
            style="float: right !important;margin: 0 10px 0px 0;font-size: 17px;cursor: pointer;" (click)="close()"></i>
        Add XPCN(s)
    </h1>
</div>

<div class="col-sm-12 mt-2 p-0 ml-0 mr-0 ">
    <div class="row mb-2" *ngIf="allotedLRNumberDetails.showInputForAllotedXPCNNumber">
        <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;margin-bottom: 8px;">
            <div class="toggle-btn" [class.active]="allotedLRNumberDetails.autoAllocateXPCNNumber" (click)="setXPCNSeriesAllocateMode()"
                style="margin-right: 8px;">
            </div>
            <p style="margin: 0;">
                {{ allotedLRNumberDetails.autoAllocateXPCNNumber ? 'Auto' : 'Manual' }}
            </p>
        </div>
        <div class="col-sm-12">
             <input [disabled]="this.allotedLRNumberDetails.autoAllocateXPCNNumber" (keyup)="onUserEnteringXPCNNumber($event.target.value)" [(ngModel)]="allotedLRNumberDetails.allotedXPCNNumber" type="number" class="form-control"
        placeholder="Please Enter XPCN Number" style="margin-bottom: 8px;">
        </div>
    </div>

   
 <div class="table table-responsive">
    <table id="example3" class="table table-bordered table-hover p-0 m-0" matSort>
        <thead class="tbl-head m-0 p-0">
            <tr>
                <th class="text-center">S.No</th>
                <th class="text-center">LCL XPCN Code</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let xpcnDetail of xpcnDetails; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ xpcnDetail.LCLXPCNCode }}</td>
            </tr>
        </tbody>
    </table>
</div>

</div>
<div>
    <a  class="custom-button add_btn" 
        (click)="addLCLOrderAndXPCN()" >
        Add XPCN
    </a>
</div>